import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DiffItem, GoalDiffAction } from '../../coaching-base/diff-decorator';
import { EntityType, GoalStatus } from '../../coaching-base/general';
import { TranslationKeyMap } from '../../coaching-insight/coaching-insight.i18n';
import { CmpsDatePipe } from '../../common/date.pipe';
import { CmpsDecimalPipe } from '../../common/number.pipe';
import { GoalDiffContextView } from '../commitment/goal-diff-context-view.model';

// TODO consolidate
const goalStatusTranslationMap = {
    [GoalStatus.DRAFT]: TranslationKeyMap._9476_DRAFT,
    [GoalStatus.PRE_APPROVAL]: TranslationKeyMap._9495_PRE_APPROVAL,
    [GoalStatus.ACTIVE]: TranslationKeyMap._125_ACTIVE,
    [GoalStatus.PENDING_CLOSE]: TranslationKeyMap._7441_PENDING_CLOSE,
    [GoalStatus.CLOSED]: TranslationKeyMap._7440_CLOSED,
    [GoalStatus.DELETED]: TranslationKeyMap._9496_DELETED,
    [GoalStatus.UPDATING]: TranslationKeyMap._8702_UPDATING,
};

@Pipe({
    name: 'cmpsDiffItemActionValue',
})
export class CmpsDiffItemActionValuePipe implements PipeTransform {
    constructor(
        private readonly _decimalPipe: CmpsDecimalPipe,
        private readonly _datePipe: CmpsDatePipe,
        private readonly _translateService: TranslateService,
    ) {}

    transform(value: DiffItem, which: 'before' | 'after'): string {
        switch (value.entityTypeId) {
            case EntityType.Note: {
                // TODO revise. either implement or make this pipe exclusive for goals
                return null;
            }
            case EntityType.CoachingEvent:
                // TODO revise. either implement or make this pipe exclusive for goals
                return null;
            case EntityType.Goal: {
                const ctx = value.context as GoalDiffContextView;
                switch (ctx.action) {
                    case GoalDiffAction.SET_VALUE:
                    case GoalDiffAction.UPDATE_VALUE: {
                        const val =
                            which === 'before'
                                ? ctx.goalValueBefore
                                : ctx.goalValueAfter;
                        return (
                            this._decimalPipe.transform(val, '1.0-2') ||
                            '0' /* should only occur for SET_VALUE */
                        );
                    }
                    case GoalDiffAction.UPDATE_EXPECTED_ACHIEVEMENT_DATE: {
                        const val =
                            which === 'before'
                                ? ctx.estimatedCompletionDateBefore
                                : ctx.estimatedCompletionDateAfter;
                        return this._datePipe.transform(val, 'LLL-dd-y');
                    }
                    case GoalDiffAction.CLOSE: {
                        const val =
                            which === 'before'
                                ? ctx.statusIdBefore
                                : ctx.statusIdAfter;
                        return this._translateService.instant(
                            goalStatusTranslationMap[val],
                        );
                    }
                }
            }
        }
    }
}
